import { ensureTemporal } from "./time"

await ensureTemporal()
